import { useMutation, useQueryClient } from '@tanstack/react-query'
import { getRouteApi, useNavigate } from '@tanstack/react-router'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { recipeQuery, saveRecipe } from '@/api'
import { LanguagesConfig, Recipe, RecipeTag, TempRecipe } from '@/api/types'
import { Button } from '@/components/Button'
import { Select } from '@/components/Select'
import RecipesTable from './RecipesTable'

const routeApi = getRouteApi('/recipes')

type Props = {
  recipes: Recipe[]
  totalCount: number
  tags: RecipeTag[]
  languages: LanguagesConfig
}

export default function RecipeList(props: Props) {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { idIngredient, ingredientName } = routeApi.useSearch()
  const queryClient = useQueryClient()

  const removeIngredientFilter = () => {
    navigate({
      to: '/recipes',
      search: (search) => ({
        ...search,
        idIngredient: undefined,
        ingredientName: undefined,
      }),
    })
  }

  const updateMutation = useMutation({
    mutationFn: (recipe: TempRecipe) => saveRecipe(recipe),
    onSuccess: (res) => {
      const recipe = res.data
      queryClient.removeQueries({
        queryKey: recipeQuery(recipe.idRecipe + '').queryKey,
      })
      queryClient.removeQueries({ queryKey: ['recipes'] })
    },
  })

  return (
    <div style={{ flexGrow: 1 }}>
      {idIngredient && (
        <div className="RecipeFilters">
          {t('recipe.filterByIngredient')}
          <div className="RecipeFilters-tag">
            {ingredientName}
            <Button onPress={removeIngredientFilter} slot="remove">
              <svg height="14" width="14" viewBox="0 0 20 20" aria-hidden="true" focusable="false">
                <path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"></path>
              </svg>
            </Button>
          </div>
        </div>
      )}
      <RecipesTable {...props} saveRecipe={updateMutation} />
    </div>
  )
}
